export default __webpack_public_path__ + "static/media/partner (13).0620f3bb.png";